import React from "react"
import { Button, Form } from "react-bootstrap"
import { blockingFetchService } from "../../../lib/blockingFetch"
import {
  AccountUsage,
  GLAccountTypes,
  GLAccountUsages,
  sortGLAccounts,
  validateTextState,
  VALIDATION_TYPE
} from "../../../lib/utils"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import FormControlInlineCheckbox from "../../fragments/FormControl.Inline.Checkbox"
import FormControlInlineInput from "../../fragments/FormControl.Inline.Input"
import FormControlInlineSelect from "../../fragments/FormControl.Inline.Select"
import FormControlInlineTextArea from "../../fragments/FormControl.Inline.TextArea"
import ProcessesStatus from "../../fragments/ProcessesStatus"
import { browserHistory } from "react-router"
import FontAwesome from "react-fontawesome"
import CustomBreadCrumb from "../../fragments/CustomBreadCrumb"
import { DckActionCreators, DckSelectors } from "dck-redux"
import * as ItemTypes from "../../../redux/items/types"
import { connect } from "react-redux"

class FormGLAccount extends React.Component {

  constructor(props) {
    
    super(props)
    const { glAccount } = this.props,
    isNew = !glAccount

    this.state = {
      isNew,
      running: false,
      success: false,
      error: null,
      name: isNew ? '' : glAccount.name,
      manualEntriesAllowed: isNew ? true : glAccount.manualEntriesAllowed,
      disabled: isNew ? false : glAccount.disabled,
      parentId: (isNew || !glAccount.parentId) ? '' : glAccount.parentId,
      type: isNew ? '' : glAccount.type,
      usage: isNew ? AccountUsage.DETAIL : glAccount.usage,
      description: isNew ? '' : glAccount.description,

      nameValidationState: VALIDATION_TYPE.NULL,
      typeValidationState: VALIDATION_TYPE.NULL,
      usageValidationState: VALIDATION_TYPE.SUCCESS,
      descriptionValidationState: VALIDATION_TYPE.NULL,
      parentIdValidationState: VALIDATION_TYPE.NULL,
      manualEntriesValidationState: VALIDATION_TYPE.NULL,
      disabledValidationState: VALIDATION_TYPE.NULL,
    }
  }

  componentDidMount() {

    const { isNew } = this.state
    if(!isNew) {
      this.validateAllValues()
    }
    this.props.loadData()
  }

  nameChanged = name => this.setState({
    name,
    nameValidationState: validateTextState(name, false),
    error: null,
  })

  typeChanged = type => {

    this.setState({
      type,
      typeValidationState: validateTextState(type, false),
      error: null,
    })
    this.parentIdChanged('')
  } 

  usageChanged = usage => this.setState({
    usage,
    usageValidationState: validateTextState(usage, false),
    error: null,
  })

  descriptionChanged = description => this.setState({
    description,
    descriptionValidationState: validateTextState(description, true),
    error: null,
  })

  manualEntriesAllowedChanged = () => this.setState({ 
    manualEntriesAllowed: !this.state.manualEntriesAllowed
  })

  disabledChanged = () => this.setState({
    disabled: !this.state.disabled
  })

  parentIdChanged = parentId => this.setState({
    parentId,
    parentIdValidationState: validateTextState(parentId, true),
    error: null,
  })

  validateAllValues = () => {

    const { name, type, usage, description, parentId } = this.state
    this.setState({
      nameValidationState: validateTextState(name, false),
      typeValidationState: validateTextState(type, false),
      usageValidationState: validateTextState(usage, false),
      descriptionValidationState: validateTextState(description, true),
      parentIdValidationState: validateTextState(parentId, true),
    })
  }

  valid = () => {

    const { name, type, usage, description, parentId } = this.state
    return (
      validateTextState(name, false) === VALIDATION_TYPE.SUCCESS &&
      validateTextState(type, false) === VALIDATION_TYPE.SUCCESS &&
      validateTextState(usage, false) === VALIDATION_TYPE.SUCCESS &&
      validateTextState(description, true) !== VALIDATION_TYPE.ERROR &&
      validateTextState(parentId, true) !== VALIDATION_TYPE.ERROR
    )
  }

  saveClicked = () => {

    if(this.valid()) {
      this.saveGLAccount()
    }
    else {
      this.validateAllValues()
      this.setState({ error: 'Some fields are incorrect.' })
    }
  }

  saveGLAccount = () => {

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { isNew, name, type, usage, description, manualEntriesAllowed, disabled,
      parentId } = this.state,

      data = { name, type, usage, description, manualEntriesAllowed, disabled,
        parentId: parentId ? parentId : null },

      { glAccount } = this.props

    blockingFetchService(
      accessToken => isNew
        ? apiServerApi.createGLAccount(accessToken, data)
        : apiServerApi.updateGLAccount(accessToken, glAccount.id, data),
      _ => {
        this.setState({ success: true })
        setTimeout(() => browserHistory.push('/glaccounts'), 1000)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  filterGLAccounts = (item, currentType, isNew) => {

    const { id, usage: usageItem, type: typeItem, fineractId, disabled } = item,
      { glAccount } = this.props,
      glAccountId = isNew ? null : glAccount.id

    return usageItem === AccountUsage.HEADER && currentType === typeItem && fineractId > 0
      && (!glAccountId || id !== glAccountId) && !disabled
  }

  renderForm = () => {

    const { isNew, error, success, running, name, type, usage, description, manualEntriesAllowed,
      disabled, parentId, nameValidationState, typeValidationState, usageValidationState,
      descriptionValidationState, manualEntriesValidationState, disabledValidationState,
      parentIdValidationState } = this.state,

    { glAccounts } = this.props,

    glAccountsData = glAccounts
      .filter(item => this.filterGLAccounts(item, type, isNew))
      .map(({id, name, glCode}) => ({ value: id, title: `${name} (${glCode})` }))

    return (
      <div className="simple-form max-width-700 mx-auto mb-20">
        <Form horizontal onSubmit={e => { e.preventDefault(); this.saveClicked()}}>

          <h3 className="text-center">
            { isNew ? 'New GL account' : 'Update GL account' }
          </h3>
          <hr />

          <FormControlInlineInput controlId="name" validationState={ nameValidationState }
            label='Name' placeholder='Enter name' value={ name }
            onChange={ this.nameChanged }
            helpText={ nameValidationState === VALIDATION_TYPE.ERROR ? 'Name is required' : '' }
          />

          <FormControlInlineSelect
            controlId='type' validationState={ typeValidationState }
            label='Account type' value={ type }
            onChange={ this.typeChanged }
            options={ GLAccountTypes }
            withEmptyOption={ true }
          />

          <FormControlInlineSelect
            controlId='usage' validationState={ usageValidationState }
            label='Account usage' value={ usage }
            onChange={ this.usageChanged }
            options={ GLAccountUsages }
            withEmptyOption={ true }
          />

          <FormControlInlineSelect
            controlId='parentId' validationState={ parentIdValidationState }
            label='Parent (Optional)' value={ parentId }
            onChange={ this.parentIdChanged }
            options={ glAccountsData }
            withEmptyOption={ true }
          />

          <FormControlInlineTextArea
            controlId='description' validationState={ descriptionValidationState }
            label='Description (Optional)' value={ description }
            onChange={ this.descriptionChanged }
          />

          <FormControlInlineCheckbox
            controlId='manualEntriesAllowed' label='Manual Entries Allowed'
            validationState={ manualEntriesValidationState } value={ manualEntriesAllowed }
            onChange={ this.manualEntriesAllowedChanged }
          />

          <FormControlInlineCheckbox
            controlId='disabled' label='Disabled'
            validationState={ disabledValidationState } value={ disabled }
            onChange={ this.disabledChanged }
          />
        </Form>

        <ProcessesStatus error={ error } running={ running } success={ success } />

        <div className="align-right mt-30">
          <Button onClick={() => browserHistory.push('/glaccounts')} className="w-100" disabled={ running }>
            <FontAwesome name='close' /> Cancel
          </Button>

          &nbsp; &nbsp;
          <Button bsStyle="success" onClick={ this.saveClicked } className="w-120" disabled={ running }>
            <FontAwesome name='save' /> Save
          </Button>
        </div>
      </div>
    )
  }

  render() {

    const { isNew } = this.state,
    dataBreadCrumbs = [
      { url: '/accounting', title: 'Accounting' },
      { url: '/glaccounts', title: 'GL accounts' }
    ]

    return (
      <div>
        <CustomBreadCrumb activeText={ isNew ? 'New' : 'Update' } data={ dataBreadCrumbs } />
        { this.renderForm() }
      </div>
    )
  }
}

const mapStateToProps = state => {
  const glAccounts = DckSelectors.selectAllItems(state, ItemTypes.GLAccount)
  sortGLAccounts(glAccounts)
  return { glAccounts }
}

const mapDispatchToProps = dispatch => ({
  loadData: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.GLAccount)),
})

export default connect(mapStateToProps, mapDispatchToProps)(FormGLAccount)



// WEBPACK FOOTER //
// ./src/components/Accounting/GLAccounts/Form.js